import { ImSpinner3 } from 'react-icons/im';

export default function LoadingSpinner() {
	return (
		<span className='animate-[spin_0.5s_ease-in-out_infinite]'>
			<ImSpinner3 />
		</span>
	);
}
